import React, { createContext, useContext, useState, useCallback } from 'react';

const FeedbackContext = createContext(null);

export function FeedbackProvider({ children }) {
  const [open, setOpen] = useState(false);
  // prefilledQuery: a query_history entry object, or null
  const [prefilledQuery, setPrefilledQuery] = useState(null);

  const openFeedbackFor = useCallback((query) => {
    setPrefilledQuery(query || null);
    setOpen(true);
  }, []);

  const openFeedback = useCallback(() => {
    setPrefilledQuery(null);
    setOpen(true);
  }, []);

  const closeFeedback = useCallback(() => {
    setOpen(false);
    // Keep prefilledQuery so the modal can animate out gracefully
    // It will be cleared on next open
  }, []);

  return (
    <FeedbackContext.Provider value={{ open, setOpen, prefilledQuery, setPrefilledQuery, openFeedbackFor, openFeedback, closeFeedback }}>
      {children}
    </FeedbackContext.Provider>
  );
}

export function useFeedback() {
  const ctx = useContext(FeedbackContext);
  if (!ctx) throw new Error('useFeedback must be used within a FeedbackProvider');
  return ctx;
}
